module.exports = __webpack_public_path__ + "abd1bb50ead2f7bcf5c7aac601fc2d87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/user.svg
// module id = 789
// module chunks = 0